export default __webpack_public_path__ + "static/weird-46e6cb425c4765aab3053a3d9fe5cbfe.jpg";